import { TESTIMONIALS } from '@constants/testimonials'

interface TestimonialsSectionProps {
  readonly title?: string
  readonly className?: string
  /** Ativa animação de scroll da landing (requer observer na página). */
  readonly animateOnReveal?: boolean
}

export function TestimonialsSection({
  title = 'O que dizem os donos de oficina',
  className = 'bg-gradient-to-b from-secondary-800 to-[#1a2d47] px-5 py-10 sm:px-8 sm:py-12',
  animateOnReveal = false,
}: TestimonialsSectionProps) {
  return (
    <section id="testemunhos" className={className}>
      <div className="mx-auto max-w-6xl">
        <p className="mb-6 text-center text-xs font-medium uppercase tracking-widest text-white/35 sm:text-sm">
          {title}
        </p>
        <div
          className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3"
          {...(animateOnReveal ? { 'data-reveal': true } : {})}
        >
          {TESTIMONIALS.map((t) => (
            <article
              key={t.name}
              className="flex flex-col gap-3.5 rounded-2xl border border-white/12 bg-white/[0.06] p-6 transition-colors hover:border-primary-400/30 hover:bg-white/[0.09]"
            >
              <p className="flex-1 text-sm italic leading-relaxed text-white/85">&ldquo;{t.text}&rdquo;</p>
              <div className="flex items-center gap-3">
                <span
                  className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-700 text-sm font-bold text-white"
                  aria-hidden
                >
                  {t.initials}
                </span>
                <div>
                  <div className="text-sm font-semibold text-white">{t.name}</div>
                  <div className="text-xs text-white/50">{t.role}</div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
